import Vue from "vue";
import VueRouter from "vue-router";
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

Vue.use(VueRouter);
const routes = [
  {
    path: "",
    redirect: "/Home",
  },

  {
    path: "/DrawForAPrize",
    name: "DrawForAPrize",
    component: () => import("../views/DrawForAPrize/DrawForAPrize.vue"),
    meta: {
      title: "年会抽奖活动",
    },
  },
  {
    path: "/voteUser",
    name: "voteUser",
    component: () => import("../views/voteUser/voteUser.vue"),
    meta: {
      title: "投票活动",
    },
  },
  {
    path: "/bigVotePh",
    name: "bigVotePh",
    component: () => import("../views/voteUser/bigVotePh.vue"),
    meta: {
      title: "投票活动排行榜",
    },
  },
  {
    path: "/votePaiHang",
    name: "votePaiHang",
    component: () => import("../views/voteUser/votePaiHang.vue"),
    meta: {
      title: "排行榜",
    },
  },
  {
    path: "/Home",
    name: "Home",
    component: () => import("../views/Home.vue"),
    meta: {
      title: "活动管理",
    },
    children: [
      {
        path: "",
        redirect: '/Home/activityList',
      },
      {
        path: 'activityList',
        name: 'activityList',
        component: () => import('../views/activityList/activityList'),
      },
      {
        path: 'prize',
        name: 'prize',
        component: () => import('../views/prize/prize'),
      },
      {
        path: 'activityUser',
        name: 'activityUser',
        component: () => import('../views/activityUser/activityUser'),
      },
      {
        path: 'WinningRecord',
        name: 'WinningRecord',
        component: () => import('../views/WinningRecord/WinningRecord'),
      },
    ],
  },
];

const router = new VueRouter({
  routes,
});

export default router;
